export type PointsBenefitsLayoutMode = 'yearly' | 'unified'

export interface PointsBenefitsPresentationData {
  featuredBenefits?: {
    data?: Record<string, any>
  }
  remainingBenefits?: {
    data?: Record<string, any>
  }
  defaultBenefitYear?: string
}

export interface PointsBenefitsLayoutCapabilities {
  showAvailableToBorrow: boolean
  showBreakdown: boolean
  showYearSelector: boolean
  useMembershipPointsTotals: boolean
}

export const getPointsBenefitsLayoutMode = (data?: PointsBenefitsPresentationData | null): PointsBenefitsLayoutMode => {
  const hasUnifiedFeaturedData = Boolean(data?.featuredBenefits?.data?.allYears)
  const hasUnifiedRemainingData = Boolean(data?.remainingBenefits?.data?.allYears)

  return hasUnifiedFeaturedData || hasUnifiedRemainingData ? 'unified' : 'yearly'
}

export const getPointsBenefitsEffectiveYearKey = (
  layoutMode: PointsBenefitsLayoutMode,
  defaultBenefitYear?: string,
): string => (layoutMode === 'unified' ? 'allYears' : (defaultBenefitYear ?? ''))

export const getPointsBenefitsLayoutCapabilities = (
  layoutMode: PointsBenefitsLayoutMode,
): PointsBenefitsLayoutCapabilities => ({
  showAvailableToBorrow: layoutMode === 'unified',
  showBreakdown: layoutMode === 'unified',
  showYearSelector: layoutMode === 'yearly',
  useMembershipPointsTotals: layoutMode === 'unified',
})

export const resolvePointsBenefitsLayoutCapabilities = (
  layoutMode: PointsBenefitsLayoutMode | undefined,
  layoutCapabilities?: PointsBenefitsLayoutCapabilities,
): PointsBenefitsLayoutCapabilities => {
  if (layoutCapabilities) {
    return layoutCapabilities
  }

  return getPointsBenefitsLayoutCapabilities(layoutMode ?? 'yearly')
}
